// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"233":"07f59b5b","592":"2fe0a815"}[chunkId] + ".chunk.js");